import React from 'react'
import Header from '../components/Header/Header'
import Footer from '../components/Header/Footer'
import Service from '../components/Servicecomps/Service'
import './Servicess.css'
export const Services = () => {
  return (
    <div className='main'>
<Header />
<Service/>
<Footer/>

    </div>
  )
}
